import { Inject } from '@angular/core';

import { SdkMessageHandler, SdkMessageHandlerCallback } from './../../../../api';
import { createSubscribeModeHandler } from './../../../../utils';
import { USE_PUBLIC_URL } from './../../../utils/urls';
import { WchLoggerService } from './../../logger/wch.logger.service';

/* Copyright IBM Corp. 2018 */
const LOGGER = 'SdkSubscribeModeHandler';

/**
 * Subscribes to the active mode
 */
export class SdkSubscribeModeHandler implements SdkMessageHandler {

    handle: SdkMessageHandlerCallback;

    constructor(@Inject(WchLoggerService) loggerService: WchLoggerService) {
        // create the handler
        this.handle = createSubscribeModeHandler(USE_PUBLIC_URL, loggerService.get(LOGGER));
    }
}
